import React, {useEffect, useState} from 'react'
import {Badge, Button, Collapse, Modal, Space, Checkbox, Spin} from 'antd';
import {withTranslation} from "react-i18next";
import {httpStatus} from "../../../../lib/createRequestSaga";
import {errorHandle} from "../../../../lib/BuilderUtils";
import NoDataBlock from "../../../../components/common/NoDataBlock";
import axios from 'axios'
import styled from "styled-components";
import _ from "lodash";
import Icon from "@mdi/react";
import {mdiBullhornOutline} from "@mdi/js";

const { Panel } = Collapse;

const NoticeDiv = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 15px;
  margin-bottom:10px;
  width: 100%;
  border: 2px dashed #eee;
  line-height: 1.5;
  color: ${props => (props.white ? '#fff' : '#aaa')};
`;

const Notice = ({t}) => {

    const topNoticeKey = 'notice-0';
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [noticeList, setNoticeList] = useState([]);
    const [notReadNotices, setNotReadNotices] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [noticeLoading, setNoticeLoading] = useState(false);
    const [dontShowToday, setDontShowToday] = useState(false);
    const [showCheckbox, setShowCheckbox] = useState(true);

    const today = new Date().toISOString().split('T')[0];

    const showModal = () => {
        const saved = localStorage.getItem('hideNoticeModalDate');
        if (saved === today) {
            setShowCheckbox(false);
        } else {
            setShowCheckbox(true);
        }

        setIsModalOpen(true);
    };

    const handleCancel = () => {
        if (dontShowToday) {
            const today = new Date().toISOString().split('T')[0];
            localStorage.setItem('hideNoticeModalDate', today);
        }
        setReadNotice(topNoticeKey);
        setIsModalOpen(false);
    };

    const NoticeHeader = (notice, idx, notReadNotices) => {
        const isUnread = notReadNotices.includes(notice.id);

        return (
            <div>
                <div className='float-right' style={{ fontWeight: isUnread ? 'bold' : 'normal' }}>{notice.date}</div>
                <div className='pull-left' style={{ fontWeight: isUnread ? 'bold' : 'normal' }}>
                    {notice.title}
                </div>
            </div>
        );
    };

    function onChange(key) {
        if (Array.isArray(key) && key.length > 0) {
            setReadNotice(key[0]);
        } else if(!Array.isArray(key) && key) {
            setReadNotice(key);
        }
    }

    const setReadNotice = (key) => {
        const idx = parseInt(key.substring(key.indexOf("-") + 1));
        const noticeId = noticeList[idx]?.id || -1;

        //목록 로드 전에 모달을 닫으면 -1이 넘어온다. 서버가 무시하므로 요청 자체를 보내지 않는다.
        if (noticeId <= 0) return;

        //이미 읽은 공지면 보낼 것이 없다. 모달을 여닫을 때마다 호출되는 경로라
        //그대로 두면 서버에서 갯수 캐시만 반복해서 무효화된다.
        if (!notReadNotices.includes(noticeId)) return;

        (async () => {
            //POST Request
            try {
                //REST API Request
                const {status, data} = await axios({
                    url:`/api/notice`,
                    method:'post',
                    params:{noticeId}
                });
                if(status === httpStatus.ok) {
                    //배지는 서버가 돌려준 값을 신뢰한다 (캐시 무효화 후 재계산된 실제 갯수)
                    setUnreadCount(data?.count ?? 0);

                    //제목을 굵게 표시하는 데 쓰는 id 목록은 로컬에서 제거
                    let cloneNotReadNotices = _.cloneDeep(notReadNotices.filter(n => n !== noticeId));
                    setNotReadNotices(cloneNotReadNotices);
                }
            } catch(error) {
                //Error Exception
                errorHandle(error);
            }
        })();
    }

    //Init : 배지에 필요한 갯수만 조회한다. 목록과 본문은 모달을 열 때 로드한다.
    useEffect( () => {
        (async () => {
            //GET Request
            try {
                //REST API Request
                const {status, data} = await axios.get(`/api/notice/unread-count`);
                if (status === httpStatus.ok) {
                    const count = data?.count ?? 0;
                    setUnreadCount(count);

                    const saved = localStorage.getItem('hideNoticeModalDate');

                    if (saved === today) {
                        setShowCheckbox(false);
                    } else if(count > 0){
                        setIsModalOpen(true);
                    }
                }
            } catch(error) {
                //Error Exception
                errorHandle(error);
            }
        })()
    }, []);

    //모달이 열릴 때 목록과 본문을 로드한다. 자동 오픈과 버튼 클릭이 모두 이 경로를 지난다.
    useEffect( () => {
        if (!isModalOpen || (noticeList?.length ?? 0) > 0) return;

        (async () => {
            //GET Request
            setNoticeLoading(true);
            try {
                //REST API Request
                const {status, data} = await axios.get(`/api/notice`);
                if (status === httpStatus.ok) {
                    setNoticeList(data?.noticeList ?? []);
                    setNotReadNotices(data?.notReadNoticeIds ?? []);
                }
            } catch(error) {
                //Error Exception
                errorHandle(error);
            } finally {
                setNoticeLoading(false);
            }
        })()
    }, [isModalOpen]);

    return (
        <>
            <Space size="large">
                <Badge size="small" count={unreadCount} overflowCount={5}>
                    <Button onClick={showModal} shape="circle" type="text" icon={<Icon path={mdiBullhornOutline} size={1}></Icon>} />
                    <Modal
                        title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
                            <span>{t('index.title.notice')}</span>
                            {showCheckbox && (
                                <Checkbox
                                    checked={dontShowToday}
                                    onChange={(e) => setDontShowToday(e.target.checked)}
                                    style={{ fontSize: '13px', marginRight: '30px' }}
                                >
                                    <span style={{ fontSize: '13px', fontWeight: 'normal'}}>{t('text.dont.show.this.again.today')}</span>
                                </Checkbox>
                            )}
                        </div>}
                        open={isModalOpen} siz width={"70%"} onCancel={handleCancel} footer={[]}>
                        {
                            noticeLoading ?
                            <NoticeDiv style={{borderColor: "transparent"}}>
                                <Spin />
                            </NoticeDiv> :
                            Object.keys(noticeList).length === 0 ?
                            <NoticeDiv style={{borderColor: "transparent"}}>
                                <NoDataBlock />
                            </NoticeDiv> :
                            <Collapse accordion defaultActiveKey={topNoticeKey} onChange={onChange}>
                                {
                                    noticeList?.map(function (notice, idx) {
                                        return (
                                            <Panel header={NoticeHeader(notice, idx, notReadNotices)} key={`notice-${idx}`}>
                                                <div style={{width:"100%", overflow: "auto"}}
                                                     dangerouslySetInnerHTML={{__html:notice.content}}></div>
                                            </Panel>
                                        )
                                    })
                                }
                            </Collapse>
                        }
                    </Modal>
                </Badge>
            </Space>
        </>
    );
}

export default withTranslation()(Notice);